/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_EmptyInputs */

const es_billing_alerts_empty = /** @type {(inputs: Billing_Alerts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay alertas configuradas`)
};

const en_billing_alerts_empty = /** @type {(inputs: Billing_Alerts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No alerts have been configured yet`)
};

/**
* | output |
* | --- |
* | "No alerts have been configured yet" |
*
* @param {Billing_Alerts_EmptyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_empty = /** @type {((inputs?: Billing_Alerts_EmptyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_EmptyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_empty(inputs)
	return en_billing_alerts_empty(inputs)
});
export { billing_alerts_empty as "billing.alerts.empty" }